import { createAction } from '@reduxjs/toolkit';

const getHomePageData = createAction('homepage/getHomePageData');
const getHomePageDataSelectedUser = createAction('homepage/getHomePageDataSelectedUser');

export default {
  getHomePageData,
  getHomePageDataSelectedUser,
};
